function handleEnquiry(productTitle) {
    const table = document.getElementById("product-details");
    const rows = table.querySelectorAll("tr");

    let tableJson = {};

    rows.forEach(row => {
        const cols = row.querySelectorAll("td");
        
        if (cols.length >= 2) {
            const key = cols[0].innerText.trim();
            const value = cols[1].innerText.trim();
            tableJson[key] = value;
        }
    });

    // Convert object to readable string
    let detailsString = "";
    for (let key in tableJson) {
        detailsString += `${key}: ${tableJson[key]} \n`;
    }

    // Optional: still keep localStorage (not required)
    localStorage.setItem("enquiryData", JSON.stringify({
        title: productTitle,
        tableData: tableJson
    }));

    // ✅ Pass EVERYTHING via URL
    const url = `/pages/enquire?title=${encodeURIComponent(productTitle)}&details=${encodeURIComponent(detailsString)}`;
    
    window.location.href = url;
}
